import { useState, useEffect } from 'react';
import { GameState, GameSettings } from '@/types/game';
import { STORAGE_KEYS } from '@/lib/constants';

export function useGameState(settings: GameSettings) {
  const [gameState, setGameState] = useState<GameState>(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEYS.GAME_STATE);
      if (saved) {
        const parsed = JSON.parse(saved);
        // Ensure backward compatibility - add new fields if missing
        return {
          homeScore: parsed.homeScore ?? 0,
          awayScore: parsed.awayScore ?? 0,
          currentHalf: parsed.currentHalf ?? 1,
          timeRemaining: parsed.timeRemaining ?? settings.halfDuration * 60,
          isRunning: false,
          isHalfTimeBreak: parsed.isHalfTimeBreak ?? false,
          breakTimeRemaining: parsed.breakTimeRemaining ?? settings.halfTimeBreakDuration * 60,
          cards: parsed.cards ?? [],
          notes: parsed.notes ?? '',
        };
      }
    } catch (err) {
      console.error('Failed to load game state:', err);
    }
    
    return {
      homeScore: 0,
      awayScore: 0,
      currentHalf: 1,
      timeRemaining: settings.halfDuration * 60,
      isRunning: false,
      isHalfTimeBreak: false,
      breakTimeRemaining: settings.halfTimeBreakDuration * 60,
      cards: [],
      notes: '',
    };
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEYS.GAME_STATE, JSON.stringify(gameState));
    } catch (err) {
      console.error('Failed to save game state:', err);
    }
  }, [gameState]);

  return [gameState, setGameState] as const;
}